// 一级数组转二级数组
const getOneArr = (arr) => {
    let tree = JSON.parse(JSON.stringify(arr))
    let newData = []
    const expanded = datas => {
        if (datas && datas.length > 0) {
            datas.forEach(e => {
                newData.push(e);
                expanded(e.children);
                e.children = []
            })
        }
    }
    expanded(tree);
    return newData;
}

// 二级数组转一级数组
const secondaryArr = (data) => {
    let tree = JSON.parse(JSON.stringify(data))
    for (const i in tree) {
        tree[i].children = getOneArr(tree[i].children)
    }
    return tree
}

export const initMenu = (arr) => {
    let data = secondaryArr(arr)
    let list = [];
    data.forEach(i => {
        let {
            path,
            component,
            icon,
            title,
            level,
            buttonlist,
            controls,
            pid,
            id,
            type,
            children
        } = i;
        if (children.length > 0) {
            children = initMenu(children);
        }
        let item = {
            path: path == null ? '' : path,
            component: resolve => {
                if (component === 'layout' || component === '') {
                    require(['../views/login/layout.vue'], resolve)
                } else {
                    require(['../views/' + component + '.vue'], resolve)
                }
            },
            name: title,
            meta: {
                title: title,
                icon: icon,
                level: level,
                id: id,
                pid: pid,
                controls: controls,
                type: type
            },
            level: level,
            children: children
        };
        if (level >= 2) {
            delete item.children
        }
        list.push(item)
    })
    return list;
}